import SideBar from 'components/SideBar';
import * as React from 'react';
export const Main = ({ sidebar, children }) => (React.createElement("div", { className: "container-fluid no-pad " },
    React.createElement("div", { className: "basic-portion" },
        sidebar && React.createElement(SideBar, null),
        children)));
